// extracted by mini-css-extract-plugin
export default {"title":"style--title--90572d"};